module.exports = __webpack_public_path__ + "img/download.90b9110c.svg";